var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56124 19.9028H13.8503C18.2579 19.9028 20.021 18.1398 20.021 13.7322V8.44308C20.021 4.03549 18.2579 2.27246 13.8503 2.27246H8.56124C4.15366 2.27246 2.39062 4.03549 2.39062 8.44308V13.7322C2.39062 18.1398 4.15366 19.9028 8.56124 19.9028Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2064 14.1735C12.9104 14.1735 14.2917 12.7922 14.2917 11.0882C14.2917 9.38427 12.9104 8.00293 11.2064 8.00293C9.50243 8.00293 8.12109 9.38427 8.12109 11.0882C8.12109 12.7922 9.50243 14.1735 11.2064 14.1735Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1779 6.68002H16.1881",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.a64c7c98942b50f0acd4865512abcbe3.svg";
export { ForwardRef as ReactComponent };